'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagIrAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.72989e-05 0H28C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20C0 13.3333 -0.000175947 6.66667 2.72989e-05 0Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 6.66667H28V0H2.72989e-05L0 6.66667Z",
          fill: "#38BB56"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M0 20H28V13.3333H0V20Z",
          fill: "#DE1B27"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.33331 5.66668C1.33331 5.48258 1.48255 5.33334 1.66665 5.33334H2.33331C2.51741 5.33334 2.66665 5.48258 2.66665 5.66668V6.33334C2.66665 6.51744 2.51741 6.66668 2.33331 6.66668H1.66665C1.48255 6.66668 1.33331 6.51744 1.33331 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.99998 5.66668C3.99998 5.48258 4.14922 5.33334 4.33331 5.33334H4.99998C5.18407 5.33334 5.33331 5.48258 5.33331 5.66668V6.33334C5.33331 6.51744 5.18407 6.66668 4.99998 6.66668H4.33331C4.14922 6.66668 3.99998 6.51744 3.99998 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.66665 5.66668C6.66665 5.48258 6.81589 5.33334 6.99998 5.33334H7.66665C7.85074 5.33334 7.99998 5.48258 7.99998 5.66668V6.33334C7.99998 6.51744 7.85074 6.66668 7.66665 6.66668H6.99998C6.81589 6.66668 6.66665 6.51744 6.66665 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33331 5.66668C9.33331 5.48258 9.48255 5.33334 9.66665 5.33334H10.3333C10.5174 5.33334 10.6666 5.48258 10.6666 5.66668V6.33334C10.6666 6.51744 10.5174 6.66668 10.3333 6.66668H9.66665C9.48255 6.66668 9.33331 6.51744 9.33331 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12 5.66668C12 5.48258 12.1492 5.33334 12.3333 5.33334H13C13.1841 5.33334 13.3333 5.48258 13.3333 5.66668V6.33334C13.3333 6.51744 13.1841 6.66668 13 6.66668H12.3333C12.1492 6.66668 12 6.51744 12 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.6666 5.66668C14.6666 5.48258 14.8159 5.33334 15 5.33334H15.6666C15.8507 5.33334 16 5.48258 16 5.66668V6.33334C16 6.51744 15.8507 6.66668 15.6666 6.66668H15C14.8159 6.66668 14.6666 6.51744 14.6666 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3333 5.66668C17.3333 5.48258 17.4826 5.33334 17.6666 5.33334H18.3333C18.5174 5.33334 18.6666 5.48258 18.6666 5.66668V6.33334C18.6666 6.51744 18.5174 6.66668 18.3333 6.66668H17.6666C17.4826 6.66668 17.3333 6.51744 17.3333 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20 5.66668C20 5.48258 20.1492 5.33334 20.3333 5.33334H21C21.1841 5.33334 21.3333 5.48258 21.3333 5.66668V6.33334C21.3333 6.51744 21.1841 6.66668 21 6.66668H20.3333C20.1492 6.66668 20 6.51744 20 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22.6666 5.66668C22.6666 5.48258 22.8159 5.33334 23 5.33334H23.6666C23.8507 5.33334 24 5.48258 24 5.66668V6.33334C24 6.51744 23.8507 6.66668 23.6666 6.66668H23C22.8159 6.66668 22.6666 6.51744 22.6666 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.3333 5.66668C25.3333 5.48258 25.4826 5.33334 25.6666 5.33334H26.3333C26.5174 5.33334 26.6666 5.48258 26.6666 5.66668V6.33334C26.6666 6.51744 26.5174 6.66668 26.3333 6.66668H25.6666C25.4826 6.66668 25.3333 6.51744 25.3333 6.33334V5.66668Z",
          fill: "#9BDDAB"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M1.33331 13.6667C1.33331 13.4826 1.48255 13.3333 1.66665 13.3333H2.33331C2.51741 13.3333 2.66665 13.4826 2.66665 13.6667V14.3333C2.66665 14.5174 2.51741 14.6667 2.33331 14.6667H1.66665C1.48255 14.6667 1.33331 14.5174 1.33331 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M3.99998 13.6667C3.99998 13.4826 4.14922 13.3333 4.33331 13.3333H4.99998C5.18407 13.3333 5.33331 13.4826 5.33331 13.6667V14.3333C5.33331 14.5174 5.18407 14.6667 4.99998 14.6667H4.33331C4.14922 14.6667 3.99998 14.5174 3.99998 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M6.66665 13.6667C6.66665 13.4826 6.81589 13.3333 6.99998 13.3333H7.66665C7.85074 13.3333 7.99998 13.4826 7.99998 13.6667V14.3333C7.99998 14.5174 7.85074 14.6667 7.66665 14.6667H6.99998C6.81589 14.6667 6.66665 14.5174 6.66665 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.33331 13.6667C9.33331 13.4826 9.48255 13.3333 9.66665 13.3333H10.3333C10.5174 13.3333 10.6666 13.4826 10.6666 13.6667V14.3333C10.6666 14.5174 10.5174 14.6667 10.3333 14.6667H9.66665C9.48255 14.6667 9.33331 14.5174 9.33331 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12 13.6667C12 13.4826 12.1492 13.3333 12.3333 13.3333H13C13.1841 13.3333 13.3333 13.4826 13.3333 13.6667V14.3333C13.3333 14.5174 13.1841 14.6667 13 14.6667H12.3333C12.1492 14.6667 12 14.5174 12 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M14.6666 13.6667C14.6666 13.4826 14.8159 13.3333 15 13.3333H15.6666C15.8507 13.3333 16 13.4826 16 13.6667V14.3333C16 14.5174 15.8507 14.6667 15.6666 14.6667H15C14.8159 14.6667 14.6666 14.5174 14.6666 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M17.3333 13.6667C17.3333 13.4826 17.4826 13.3333 17.6666 13.3333H18.3333C18.5174 13.3333 18.6666 13.4826 18.6666 13.6667V14.3333C18.6666 14.5174 18.5174 14.6667 18.3333 14.6667H17.6666C17.4826 14.6667 17.3333 14.5174 17.3333 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M20 13.6667C20 13.4826 20.1492 13.3333 20.3333 13.3333H21C21.1841 13.3333 21.3333 13.4826 21.3333 13.6667V14.3333C21.3333 14.5174 21.1841 14.6667 21 14.6667H20.3333C20.1492 14.6667 20 14.5174 20 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M22.6666 13.6667C22.6666 13.4826 22.8159 13.3333 23 13.3333H23.6666C23.8507 13.3333 24 13.4826 24 13.6667V14.3333C24 14.5174 23.8507 14.6667 23.6666 14.6667H23C22.8159 14.6667 22.6666 14.5174 22.6666 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M25.3333 13.6667C25.3333 13.4826 25.4826 13.3333 25.6666 13.3333H26.3333C26.5174 13.3333 26.6666 13.4826 26.6666 13.6667V14.3333C26.6666 14.5174 26.5174 14.6667 26.3333 14.6667H25.6666C25.4826 14.6667 25.3333 14.5174 25.3333 14.3333V13.6667Z",
          fill: "#EF8D93"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12 10C12 9.41405 12.252 8.88694 12.6535 8.52115L13.1025 9.01397C12.8338 9.25875 12.6667 9.60939 12.6667 10C12.6667 10.4935 12.9348 10.9244 13.3333 11.155V10C13.3333 9.63182 13.6318 9.33334 14 9.33334C14.3682 9.33334 14.6666 9.63182 14.6666 10V11.155C15.0652 10.9244 15.3333 10.4935 15.3333 10C15.3333 9.61669 15.1725 9.27202 14.9126 9.02793L15.3691 8.54203C15.7574 8.90686 16 9.42511 16 10C16 11.1046 15.1046 12 14 12C12.8954 12 12 11.1046 12 10Z",
          fill: "#D80915"
        }
      )
    ]
  }
);
const VpFlagIrAsset = forwardRef(FlagIrAsset);

export { VpFlagIrAsset as default };
